import { type FunctionalComponent, h, type VNode } from '@stencil/core';
import type { GuidedV2Emitters } from '../../models/eventNames';

export interface SelectedSuggestion {
    suggestionURL: string;
    suggestionTitle: string;
    suggestionDescription: string;
    suggestionImage: string;
}

export interface SelectedSuggestionsParams {
  results: Array<SelectedSuggestion>;
  label: string;
  eventEmitters: GuidedV2Emitters;
}

export const SelectedSuggestions: FunctionalComponent<SelectedSuggestionsParams> = (props) => {
    const emitters = props.eventEmitters() ?? undefined;
    return <div class="guided-v2-subcomponent-selected-suggestions">
      <div class="guided-v2-products-header">
        {props.label}
      </div>
      <div class="guided-v2-subcomponent-selected-suggestions-content">
        {props.results.map(result => (
          <a
            href={result.suggestionURL}
            onClick={() => emitters?.selectedSuggestionClicked.emit(result)}
            onKeyDown={(e) => e.key === 'Enter' && emitters?.selectedSuggestionClicked.emit(result)}
            target="_blank"
          >
            <div class="guided-v2-subcomponent-selected-suggestions-block">
              <div class="guided-v2-subcomponent-selected-suggestions-icon">
                <img src={result.suggestionImage} alt={result.suggestionTitle} />
              </div>
              <div class="guided-v2-subcomponent-selected-suggestions-text">
                <p class="guided-v2-subcomponent-selected-suggestions-title">
                  {result.suggestionTitle}
                </p>
                <p class="guided-v2-subcomponent-selected-suggestions-description">
                  {result.suggestionDescription}
                </p>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div> as VNode;
};
